import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "original_main_container" }
const _hoisted_2 = { class: "title_studio" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Jingle", -1)
const _hoisted_4 = { class: "play_button_audio" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Vybroo te ofrece el servicio de Jingle (yingl). Es una producción musical corta, donde sus palabras transmiten los beneficios de tu marca. La canción de tu marca quedará grabada en la mente de tus consumidores. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/vybroo_studio/jingle.jpg",
  class: "img_servicio_studio"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"38px"} }, "JINGLE", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "$20,000*", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", null, "*Precios más IVA", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headertoolbarstudio = _resolveComponent("headertoolbarstudio")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_footerContactanos = _resolveComponent("footerContactanos")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "headerTop" }, {
        default: _withCtx(() => [
          _createVNode(_component_headertoolbarstudio)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_header, { collapse: "condense" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_text, null, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_2, [
                  _createVNode(_component_ion_icon, {
                    class: "l_close_r",
                    button: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push('/tabs/tabReproductor'))),
                    src: "assets/ICONOS/close.svg"
                  }),
                  _createVNode(_component_ion_icon, {
                    class: "icon_studio",
                    slot: "start",
                    src: "assets/ICONOS/Servicios/jingle_vybroo_studio.svg"
                  }),
                  _hoisted_3,
                  _createVNode(_component_ion_icon, {
                    class: "l_studio",
                    button: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push('/tabs/logotipoAuditivo'))),
                    slot: "end",
                    src: "assets/ICONOS/left_icon.svg"
                  }),
                  _createVNode(_component_ion_icon, {
                    class: "r_studio",
                    button: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push('/tabs/spotRadio'))),
                    slot: "end",
                    src: "assets/ICONOS/right_icon.svg"
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_grid, { class: "play_buttons_studio" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.openModal && $options.openModal(...args))),
                          class: "play_button_video"
                        }, " Ver video "),
                        _createElementVNode("span", _hoisted_4, [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            src: "assets/ICONOS/reproductor-blanco.svg"
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_text, { class: "text_studio" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_ion_grid, { class: "foot_text_studio" }, {
              default: _withCtx(() => [
                ($data.platform === 'web' || $data.platform === 'android')
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          class: "div1",
                          size: "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          class: "div2",
                          size: "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_footerContactanos)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}